// extracted by mini-css-extract-plugin
export default {"other":"index_other_VHZYL","judgesImg":"index_judgesImg_JEP9-"};